import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BudgetWizardComponent } from "./budget-wizard/budget-wizard.component";
import { BudgetPlanComponent } from "./budget-plan/budget-plan.component";
import { BudgetScannComponent } from "./budget-scann/budget-scann.component";
import { BudgetValorizationComponent } from "./budget-valorization/budget-valorization.component";
import { ReactiveFormsModule } from "@angular/forms";
import { AppMaterialModule } from "src/app/app.material.module";
import { PatientAutocompleteModule } from "../autocomplete/patient/patient-autocomplete.module";
import { ControlsModule } from "../controls/controls.module";
import { SharedModule } from "../shared.module";
import { BudgetPatientComponent } from './budget-patient/budget-patient.component';
import { BudgetReportComponent } from './budget-report/budget-report.component';
import { BudgetOrderListComponent } from './budget-order-list/budget-order-list.component';
import { BudgetOrderComponent } from './budget-order/budget-order.component';
import { BudgetObservationComponent } from './budget-observation/budget-observation.component';
import { BudgetSearchComponent } from './budget-search/budget-search.component';
import { BudgetFilterComponent } from './budget-filter/budget-filter.component';

@NgModule({
  declarations: [
    BudgetWizardComponent,
    BudgetPlanComponent,
    BudgetScannComponent,
    BudgetValorizationComponent,
    BudgetPatientComponent,
    BudgetReportComponent,
    BudgetOrderListComponent,
    BudgetOrderComponent,
    BudgetObservationComponent,
    BudgetSearchComponent,
    BudgetFilterComponent,
  ],
  imports: [
    CommonModule,
    AppMaterialModule,
    ControlsModule,
    SharedModule,
    ReactiveFormsModule,
    PatientAutocompleteModule,
  ],
})
export class BudgetModule {}
